<template>
  <TemplateLogin
    v-slot="{ validate }"
    class="forgot-password"
    :error="errorMessage"
    :success="successMessage"
  >
    <h1 class="heading--medium">
      Forgot Password
    </h1>
    <p class="body--medium">
      Enter the email associated with your account and we will send a link to reset your
      password.
    </p>
    <CalicoForm
      v-slot="{ field, error }"
      name="Email"
      label="Email"
      rules="required|email"
    >
      <CalicoField
        v-model="email"
        v-bind="field"
        :error="error"
      />
    </CalicoForm>
    <button
      class="button-primary"
      :disabled="loading"
      @click="forgotPassword(validate)"
    >
      Send Link
    </button>
  </TemplateLogin>
</template>

<script lang="js">
import CalicoField from '@/components/calico/field/index.vue'
import TemplateLogin from '@/components/template/login/index.vue'
import CalicoForm from '@/components/pattern/form/index.vue'
import { flashMessage } from '@/utils/flashMessage'
import Auth from "@/services/auth";

export default {
  name: 'ForgotPassword',
  components: {
    CalicoField,
    CalicoForm,
    TemplateLogin
  },
  data() {
    return {
      email: "",
      errorMessage: "",
      successMessage: "",
      loading: false,
      flashMessage
    }
  },
  methods: {
    async forgotPassword(validate) {
      try {
        this.errorMessage = ""
        const result = await validate();
        if (!result.valid) return;

        this.loading = true
        const response = await Auth.forgotPassword(this.email);
        flashMessage.set(response.message)
        this.$router.push('/login')
      } catch (error) {
        this.errorMessage = error.message
      }
      finally {
        this.loading = false
      }
    },
  }
}
</script>

<style lang="scss">
.forgot-password {
  p {
    margin: 0;
    text-align: center;
  }
}
</style>
